<div class="ok-cancel-dialog">
  <div class="page-h2-compact ok-cancel-dialog-title mat-dialog-title">
    <i [ngClass]="dialogIcon"></i>
    <div>{{ data.title }}</div>
  </div>

  <mat-dialog-content mat-dialog-content>
    <div [innerHTML]="data.content"></div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button
      mat-raised-button
      cdkFocusInitial
      color="accent"
      *ngIf="showOk"
      [mat-dialog-close]="true"
      (click)="onCloseConfirm()"
    >
      {{ data.oklabel }}</button
    >&nbsp;
    <button
      mat-raised-button
      [mat-dialog-close]="false"
      *ngIf="showCancel || !showOk"
      (click)="onCloseCancel()"
    >
      {{ data.cancellabel }}
    </button>
  </mat-dialog-actions>
</div>
